import Button from '@mui/material/Button';
import {useEffect} from "react";
import {IoLogOut} from "react-icons/io5";
import {NavLink, useNavigate} from "react-router-dom";
import Spinner from "react-spinners/BeatLoader";

// Pages per role (the role comes from Auth/login): admin sees all, support sees FCT and
// crashes, a factory station unlocks units (its start page) and sees its own FCT results, and a
// QA account only unlocks units (USB debugging).
export const PAGES = [
    {path: "/unlock", label: "Unlock unit", roles: ["factory", "qa"]},
    {path: "/home", label: "Updates", roles: ["admin"]},
    {path: "/fct", label: "FCT results", roles: ["admin", "support", "factory"]},
    {path: "/crashes", label: "Crashes", roles: ["admin", "support"]},
    {path: "/qa-devices", label: "QA devices", roles: ["admin"]},
];

export const role = () => localStorage.getItem("_MIHEALTHROLE") || "admin";

export const homeFor = (r) => (PAGES.find(p => p.roles.includes(r)) || PAGES[0]).path;

export default function NavBar({title, loading}) {
    const navigate = useNavigate();
    // A tab title per page, e.g. "FCT results · miHealth portal"
    useEffect(() => {
        document.title = `${title.replace(/\.$/, "")} · miHealth portal`;
    }, [title]);
    return (
        <div className="mt-3 d-flex align-items-center justify-content-between mx-3 mb-3 gap-3 flex-wrap">
            <h3 className="mb-0" style={{letterSpacing: 1}}>{title}</h3>
            <div className="d-flex gap-3">
                {PAGES.filter(p => p.roles.includes(role())).map(p =>
                    <NavLink key={p.path} to={p.path}
                             style={({isActive}) => ({fontWeight: isActive ? 700 : 400, textDecoration: "none"})}>
                        {p.label}
                    </NavLink>)}
            </div>
            <Spinner color='#00c292' loading={!!loading}/>
            <Button onClick={() => {
                localStorage.clear();
                navigate("/");
            }} variant="outlined">
                <IoLogOut size={26}/>
            </Button>
        </div>
    );
}
